module.exports = __webpack_public_path__ + "static/media/QR_bg_img.840ea976.JPG";